import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchProductDetails,
  resetProductTransactions,
  clearFetchedProduct,
  fetchProductKeys,
} from 'store/actions/products';
import styles from './products.module.scss';
import DashboardLayout from 'layout/dashboardLayout';
import moment from 'moment';
import cx from 'classname';
import { ADMIN, formatCurrency, OWNER } from 'libs';
import Table from 'components/Form/Table';
import { CaretRightIcon } from 'components/icons';
import Transactiondetails from 'container/Transactions/transactiondetails';
import Fetching from 'components/Fetching';
import EmptyState from 'components/EmptyState';
import { ProductKeys, ProductCommission } from 'components/products';
import { globalStyles } from 'styles';
import Button from 'components/button';

const ProductView = ({ history, match: { params }, location, ...props }) => {
  const dispatch = useDispatch();
  const [drawerActive, setDrawerActive] = useState(false);
  const [currentDetail, setCurrentDetail] = useState({});
  const [keyDrawer, setKeyDrawer] = useState(false);
  const [commissionDrawer, setCommissionDrawer] = useState(false);

  const { details, keys, transactions, transactionsLoading } = useSelector(
    ({
      products: {
        products: { details, keys },

        transactions: { data: transactions, inProgress: transactionsLoading },
      },
    }) => ({
      details,
      transactions,
      transactionsLoading,
      keys,
    }),
  );

  const roleChecker = useSelector((state) => state.common.user);

  useEffect(() => {
    if (params.id) {
      dispatch(fetchProductDetails(params.id));
    }

    return () => {
      dispatch(clearFetchedProduct('products'));
    };
  }, [params, dispatch]);

  useEffect(() => {
    if (details.id) {
      dispatch(fetchProductKeys(details.id));
    }
  }, [details]);

  const goToEdit = () => {
    history.push(`/products/edit/${params.id}`);
  };

  const canEdit =
    roleChecker?.merchantUser?.role === OWNER ||
    roleChecker?.merchantUser?.role === ADMIN;

  return (
    <DashboardLayout showBackIcon onGoBack={() => history.push('/products')}>
      <div className={styles.chooseBody} data-testid="product-details">
        <div className={styles.magCreate}>
          <p className={styles.chooseTitle}>{details?.title || ''}</p>
          <div className={styles.createMsgs}>
            <p className={styles.chooseSub}>
              Here you can see your product details and recent transactions
              about the product
            </p>
            <div className={styles.btns}>
              {canEdit && (
                <Button
                  className={styles.draftsBtn}
                  onClick={() => goToEdit(`/products/edit/${params.id}`)}
                  text="Edit Product"
                  variant="gray"
                />
              )}
            </div>
          </div>
        </div>

        <hr className={styles.line} />
        <div className={styles.detailsBody}>
          <div className={styles.descDiv}>
            <p className={styles.scratchTitle}>Product Description</p>

            <p className={styles.description}> {details?.description || ''}</p>
            <hr className={styles.line} />
            <div className={styles.detailsDate}>
              <div>
                <div className={styles.detailsDateTitle}>
                  <p>Amount</p>
                </div>
                <p className={styles.detailsDateContent}>
                  {details?.amount
                    ? formatCurrency(details.amount)
                    : details?.amountType}
                </p>
              </div>
              <div>
                <div className={styles.detailsDateTitle}>
                  <p>Product Code</p>
                </div>
                <p className={styles.detailsDateContent}>{details?.code}</p>
              </div>
            </div>
            <div className={styles.detailsDate}>
              <div>
                <p className={cx(styles.detailsDateTitle)}>Date Created</p>
                <p className={cx(styles.detailsDateContent)}>
                  {details?.createdAt &&
                    moment(details?.createdAt).format('MMM D, YYYY LT')}
                </p>
              </div>

              <div>
                <p className={cx(styles.detailsDateTitle)}>Date Updated</p>
                <p className={cx(styles.detailsDateContent)}>
                  {details?.createdAt &&
                    moment(details?.createdAt).format('MMM D, YYYY LT')}
                </p>
              </div>
            </div>

            <div className={styles.detailBtns}>
              <Button
                className={styles.draftsBtn}
                onClick={() => {
                  setKeyDrawer(true);
                }}
                text=" View product keys"
                variant="gray"
              />

              <ProductKeys
                drawerActive={keyDrawer}
                setDrawerActive={setKeyDrawer}
                fields={keys}
              />
              <Button
                className={styles.draftsBtn}
                onClick={() => {
                  setCommissionDrawer(true);
                }}
                text="View commissions"
                variant="gray"
              />

              <ProductCommission
                drawerActive={commissionDrawer}
                setDrawerActive={setCommissionDrawer}
                details={details}
              />
            </div>
          </div>
          <div className={styles.tableDiv}>
            <div
              className={cx(
                globalStyles.flex,
                globalStyles.justifyContentBetween,
                globalStyles.alignItemsCenter,
              )}
            >
              <p className={styles.scratchTitle}>Recent Transactions</p>
              <div
                className={cx(globalStyles.flex, globalStyles.alignItemsCenter)}
                style={{ marginRight: '10px' }}
              >
                <p
                  onClick={() => history.push('/transactions')}
                  className={styles.viewAllDetails}
                >
                  View All
                </p>
                <CaretRightIcon fill="#18379A" style={{ marginTop: '-2px' }} />
              </div>
            </div>

            <div className={cx(styles.tableTop, styles.detailsBorder)}>
              <Transactiondetails
                drawerActive={drawerActive}
                setDrawerActive={setDrawerActive}
                txtRow={currentDetail}
              />
              {transactionsLoading && <Fetching />}
              {transactions &&
                transactions.length === 0 &&
                !transactionsLoading && (
                  <EmptyState text="Your transactions will show up here as they are being made" />
                )}
              {transactions && transactions.length > 0 && (
                <Table minWidth="auto">
                  <Table.Thead>
                    <Table.Tr>
                      <Table.Th>Id</Table.Th>
                      <Table.Th>Amount</Table.Th>
                      <Table.Th>Revenue</Table.Th>
                      <Table.Th>Transaction Date</Table.Th>

                      <Table.Th> </Table.Th>
                    </Table.Tr>
                  </Table.Thead>

                  <Table.TBody>
                    {transactions.map((item, index) => (
                      <Table.Tr
                        key={index}
                        onClick={() => {
                          setCurrentDetail(item);
                          setDrawerActive(true);
                        }}
                      >
                        <Table.Td>
                          {item.parentReference
                            ? item.parentReference.substr(0, 15) + '...'
                            : '-'}
                        </Table.Td>
                        <Table.Td>
                          {item?.amount && formatCurrency(item.amount)}
                        </Table.Td>
                        <Table.Td>
                          {item?.revenue && formatCurrency(item.revenue)}
                        </Table.Td>
                        <Table.Td>
                          {item?.createdAt &&
                            moment(item?.createdAt).format('MMM D, YYYY')}
                        </Table.Td>

                        <Table.Td>
                          <div className={styles.carTop}>
                            <CaretRightIcon
                              fill="#18379A"
                              onClick={() => {
                                setCurrentDetail(item);
                                setDrawerActive(true);
                              }}
                            />
                          </div>
                        </Table.Td>
                      </Table.Tr>
                    ))}
                  </Table.TBody>
                </Table>
              )}
            </div>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default ProductView;
